import {IController} from "angular";
import * as angular from "angular";

export class AccountContractRowActionButtonComponent implements IController {

  contract: any;
  accountId: string
  onViewContractClicked: Function;
  onUnlinkContract: Function;

  onOpen($mdMenu, event) {
    $mdMenu.open(event);
  }
}

angular
  .module('bringoz.admin.contracts')
  .component('accountContractRowActionButton', {
    bindings: {
      contract: '<',
      accountId: '<',
      onViewContractClicked: '&',
      onUnlinkContract: '&',
    },
    template: require('./account-contract-row-action-button.html').default,
    controller: AccountContractRowActionButtonComponent
  });
